import Discussion from 'shared/components/discussion';
import PinMessage from 'shared/components/pin_message';
import { buildChannel } from 'shared/utilities/channel_builder';
import Page from 'shared/components/page';
import ConcurrentUsers from 'shared/components/concurrent_users';
import { VIDIO_CHAT_HOST, VIDIO_CHAT_GKE_HOST, VIDIO_CHAT_SECURE } from 'shared/env';
import SocketAPI from 'vidio-chat';
import WebSocketLivestreamingStatusListener from 'components/shared/WebSocketLivestreamingStatusListener';

export default class WebSocketConnection {
  constructor() {
    const element = '.js-component[data-component="WebSocketConnection"]'
    const chatGKEHostEnabled = $(element).data('chat-gke-host-enabled')

    this.wsConfig = {
      host: chatGKEHostEnabled ? VIDIO_CHAT_GKE_HOST : VIDIO_CHAT_HOST,
      secure: VIDIO_CHAT_SECURE
    };

    this.websocketEnabled = $(element).data('websocket-enabled')
    this.discussion = new Discussion();
    this.concurrentUsers = new ConcurrentUsers();
    this.pinMessage = new PinMessage();
    this.webSocketLivestreamingStatusListener = new WebSocketLivestreamingStatusListener();
  }

  noop() {
  }

  init() {
    if (this.websocketEnabled) {
      SocketAPI.createSession(this.wsConfig, {
        onOpenCallback: this.onOpen.bind(this),
        onMessageCallback: this.onMessage.bind(this),
        onConnectFailed: this.noop.bind(this)
      });
    }
  }

  onOpen() {
    const page_id = Page.id();
    SocketAPI.subscribe(buildChannel('utility', 'anti-piracy', page_id));
    SocketAPI.subscribe(buildChannel('ccu', 'livestreaming', page_id));
    SocketAPI.subscribe(buildChannel('livestreaming_status', 'livestreaming', page_id));
  }

  onMessage(message) {
    if (message === null) {
      return;
    }

    if (message.data) {
      try {
        const messageData = JSON.parse(message.data);

        switch(message.type) {
          case 'action':
            return;
          case 'utility/antipiracy':
            window.player.toggleWatermark(messageData.duration);
            break;
          case 'ccu/livestreaming':
            this.concurrentUsers.setConcurrentUserCount(messageData);
            break;
          case 'chat/pin':
            this.pinMessage.renderPinnedMessage(messageData);
            break;
          case 'chat/unpin':
            this.pinMessage.hidePinnedMessageDisplay();
            break;
          case 'chat/message':
            this.discussion.receive(messageData);
            break;
          case 'livestreaming_status':
            this.webSocketLivestreamingStatusListener.run(messageData);
            break;
        }
      } catch (e) {
        console.error('Error when processing data:', e);
      }
    }
  }
}
